<template>
    <dropdown
        :selected="filteredEmailIntegrations.filter(x => x.id === emailIntegrationId)"
        :items="filteredEmailIntegrations"
        name-key="name"
        value-key="id"
        show-selected-first
        @input="$emit('update-email-integration-id', $event.id)"
    >
        <template v-slot="{ on }">
            <v-text-field
                :value="senderTextFieldValue"
                readonly
                class="pt-0 mt-0 subtitle-2 setup-email-wrapper"
                hide-details
                v-on="on"
            >
                <template v-slot:prepend-inner>
                    <div class="subtitle-2 n3--text mr-1 ml-2" style="margin-top: 2px">{{ $t("__From_email") }}</div>
                </template>
                <template v-slot:append>
                    <v-btn
                        text
                        class="px-2 body-2 mt-0 set-up-email"
                        style="min-width: unset; text-transform: unset"
                        small
                        color="n3"
                        @click="onSetupEmailClick"
                    >
                        {{ $t("Set up email") }}
                    </v-btn>
                </template>
            </v-text-field>
        </template>
    </dropdown>
</template>

<script>
import PersonAvatar from "../../../components/PersonAvatar";
import { $t } from "@/i18n";
import {computed, onMounted, ref} from "@vue/composition-api";
import AppModule from "../../../store/modules/app";
import {APP_STORE_APP_TYPES, EMAIL_CUSTOM_SENDERS} from "@/helpers/constants";
import AccountModule from "../../../store/modules/account";
import DialogModule, {actions} from "@/store/modules/dialog";
import {Router} from "@/composables/Router";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import TaskModule from "@/store/modules/task";
import ApiEmailAutomationContacts from "../../../api/email_automation/contacts"
import errorDialog from "@/views/ErrorDialog/errorDialog";

export default {
    name: "TaskAddEmailControlFromSelection",
    components: {
        PersonAvatar
    },
    props: {
        emailIntegrationId: {
            type: Number,
            default: null
        },
        accountId: {
            type: Number,
            default: null
        },
        clientId: {
            type: Number,
            default: null
        },
    },
    setup (props, ctx) {
        const router = Router();
        const appModule = AppModule();
        const dialogModule = DialogModule();
        const { appStoreDialogActions } = appStoreDialog()
        const { closeTask } = TaskModule();
        const { current_account } = AccountModule();

        const emailIntegrations = ref([]);

        onMounted(async () => {
            try {
                const data = await ApiEmailAutomationContacts.getTaskFromContacts(props.accountId, props.clientId)
                emailIntegrations.value = data.from_contacts

                if (filteredEmailIntegrations.value.length && !props.emailIntegrationId) {
                    ctx.emit('update-email-integration-id', filteredEmailIntegrations.value[0].id)
                }

            } catch (ex) {
                errorDialog.showError(ex)
            }
        })

        const filteredEmailIntegrations = computed(() => {
            let ret = emailIntegrations.value.filter(emailIntegration => {
                // Always show the selected email integration if it is selected
                if (emailIntegration.id === props.emailIntegrationId) {
                    return true
                }

                // Don't show other persons email integrations
                if (emailIntegration.visibility === 'private' && emailIntegration.owner_id !== current_account.value.id) {
                    return false
                }

                return true
            })

            if (ret.length === 0 || !ret.find(x => x.visibility === 'private' && x.owner_id === current_account.value.id)) {
                ret.push({
                    id: null,
                    email: null,
                    name: appModule.info_email.value,
                    owner_id: null,
                    visibility: 'public'
                })
            }

            ret.push({
                id: -1,
                email: '',
                name: $t('Client default'),
                owner_id: null,
                visibility: 'public'
            })

            return ret
        })

        const onSetupEmailClick = () => {
            dialogModule.setDialogOptions({
                component: () => import("@/views/Dialog/NavigationWarningDialog"),
                payload: {
                    type: "clients_plan",
                    title: $t("Leave page?"),
                    description: $t(
                        "Changes that you made may not be saved"
                    ),
                    cancelButton: $t("Cancel"),
                    confirmButton: $t("Leave"),
                    nextVal: () => {
                        closeTask()

                        router.push({ name: 'app_store', params: { accountId: props.accountId } })

                        appStoreDialogActions.openAppStoreModal(
                            APP_STORE_APP_TYPES.EMAILING,
                            props.accountId,
                            {
                                dialogOptions: { defaultTab: 'settings' },
                                onUpdate: () => {
                                }
                            }
                        )
                    }
                }
            });
        }

        const selectedEmailIntegration = computed(() => filteredEmailIntegrations.value.find(x => x.id === props.emailIntegrationId))

        const senderTextFieldValue = computed(() => {
            if (!selectedEmailIntegration.value) {
                return ''
            }

            if (!selectedEmailIntegration.value.email) {
                return selectedEmailIntegration.value.name
            }

            return `${selectedEmailIntegration.value.name} (${selectedEmailIntegration.value.email})`
        })

        return {
            onSetupEmailClick,
            senderTextFieldValue,
            emailIntegrations,
            filteredEmailIntegrations,
        }
    }
}
</script>

<style scoped lang="scss">
.v-input {
    ::v-deep .v-input__slot {
        &::before {
            border-color: var(--v-g3-base) !important;
        }
    }
}

.setup-email-wrapper {
    ::v-deep .v-input__append-inner {
        margin-top: 0 !important;

        .set-up-email {
            height: 32px;
        }
    }
}

</style>